import axios from 'axios';
import { getPageRenderSaveEndpoint } from '../../../utils/pageRenderStorage';

// These wrappers intentionally return the Axios response. Callers currently
// depend on both response.data and response.status while the edit-page feature
// is being decomposed.
export const getPage = (pageId, pageLanguage) => axios.get(
  `/api/page/${pageId}`, { params: { plang: pageLanguage || undefined } },
);

export const getBook = (bookId) => axios.get(`/api/book/${bookId}`);

export const getPreviousPage = (pageId, pageLanguage) => axios.get(
  `/api/page/${pageId}/previous`, { params: { plang: pageLanguage || undefined } },
);

export const getNextPage = (pageId, pageLanguage) => axios.get(
  `/api/page/${pageId}/next`, { params: { plang: pageLanguage || undefined } },
);

export const getPageTextItems = (pageId) => axios.get(
  `/api/page/${pageId}/text-items`,
  { withCredentials: true },
);

export const savePageTextItems = (pageId, textItems) => axios.put(
  `/api/page/${pageId}/text-items`,
  { text_items: textItems },
  { withCredentials: true },
);

export const savePageTextItem = (pageId, itemId, textItem) => axios.put(
  `/api/page/${pageId}/text-items/${itemId}`,
  { text_item: textItem },
  { withCredentials: true },
);

export const getPageTextEntries = (pageId) => axios.get(
  `/api/page/${pageId}/text-entries`,
  { withCredentials: true },
);

export const savePageTextEntries = (pageId, pageTextEntries) => axios.put(
  `/api/page/${pageId}/text-entries`,
  { page_text_entries: pageTextEntries },
  { withCredentials: true },
);

export const saveRichText = (pageId, field, contentHtml) => axios.post(
  '/api/save_rich_text',
  { page_id: pageId, field, content_html: contentHtml },
);

export const translatePageText = (pageId, targetLanguage, text) => axios.post(
  '/api/translate_text',
  { page_id: pageId, target_lang: targetLanguage, text },
);

export const updatePageText = (pageId, field, newText) => axios.post(
  '/api/update_text',
  { page_id: pageId, field, new_text: newText },
);

export const resetPageCanvas = (pageId, pageLanguage) => axios.post(
  `/api/page/${pageId}/reset-canvas?plang=${encodeURIComponent(pageLanguage)}`,
);

export const saveCanvasImage = (formData) => axios.post(
  getPageRenderSaveEndpoint(),
  formData,
);
